import NavigationTab from "./NavigationTab";

export default NavigationTab;

export * from "./NavigationTab";
